// extracted by mini-css-extract-plugin
export default {"checklistDetails":"ChecklistDetails_checklistDetails__S7kcW","editBtn":"ChecklistDetails_editBtn__ZqYKC","deleteBtn":"ChecklistDetails_deleteBtn__uk-3O"};